import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class ListAlertStatusRequest extends BaseServiceRequest {

    constructor(listId) {
        super();
        super.addRequestUri("getliststatus.pb");
        super.addPathParameter(listId.toString());
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.ALERTS;
    }

    getMessageName() {
        return "ListAlertStatusDataResponse";
    }
}

export default ListAlertStatusRequest;
